import { observer } from "mobx-react";
import * as React from "react";
import { AppStore } from "../../stores/AppStore";
import { Tab, Tabs } from "@blueprintjs/core";
import Contestacoes from "./Contestacoes";
import { ResultadoStore } from "../../stores/resultados/ResultadoStore";
import ResultadosCalculos from "./ResultadosCalculos";
import Relatorios from "./Relatorios";
import { AppIcon } from "../utils/AppIcon";
import NaoContestadosRs from "./nao-contestados/nao_contestados_rs";
import NaoContestados from "./nao-contestados/nao_contestados";

@observer
export default class ResultadosPage extends React.Component<{}, {}> {

  constructor(props) {
    super(props);

    AppStore.setTitle("Resultados de Cálculos");

  }

  /**
 * Carrega dados e atualiza o estado de acordo com a aba selecionada na interface de resultados.
 * 
 * A função:
 * - Converte o identificador da aba (`tabId`) para string para evitar inconsistências.
 * - Executa ações específicas dependendo da aba selecionada:
 * 
 *   **Aba "contestacoes"**:
 *   1. Chama `handleConsultaTodas(1, 15)` para buscar a primeira página de contestações.
 *   2. Chama `handldeItensProcessando()` para carregar itens em processamento.
 * 
 *   **Aba "relatorios"**:
 *   1. Reinicia a paginação (`page_tasks_relatorio = 1` e `length_tasks_relatorio = 0`).
 *   2. Chama `handleTasksPaged(1)` para buscar os relatórios mais recentes.
 * 
 * - Por fim, define `selectedResultadosTab` com o valor da aba selecionada.
 * 
 * @async
 * @param {string|number} tabId Identificador da aba a ser carregada.  
 * Pode ser `"contestacoes"` ou `"relatorios"`.
 * 
 * @returns {Promise<void>} Retorna uma Promise resolvida após carregar os dados da aba selecionada.
 */

  async handldeChargeTab(tabId) {

    ResultadoStore.resetContestarItems();

    if (String(tabId) == "contestacoes") {

      await ResultadoStore.handleConsultaTodas(1, 15);
      await ResultadoStore.handldeItensProcessando();

    }

    if (String(tabId) == "relatorios") {

      ResultadoStore.obs.page_tasks_relatorio = 1
      ResultadoStore.obs.length_tasks_relatorio = 0

      await ResultadoStore.handleTasksPaged(1)

    }

    ResultadoStore.obs.selectedResultadosTab = String(tabId);

  }

  handleContestarLoteCalculados = (): void => {
  
      ResultadoStore.obs.openContestacaoLoteCalculados = true;
  
    };

  alertaSefa() {

    if (!AppStore.obs1.selectedEmpresa.razao_social || !(AppStore.obs1.selectedEmpresa.uf == "PA")) return null

    if (ResultadoStore.obs.sefa) {

      return (<div className="alert alert-success" style={{ display: "inherit" }}>
        <AppIcon size={20} name="check_circle" style={{ marginRight: 10 }} />
        Consta solicitação SEFA concluída referente ao período selecionado.
      </div>)

    } else {

      return (<div className="alert alert-warning" style={{ display: "inherit" }}>
        <AppIcon size={20} name="warning" style={{ marginRight: 10 }} />
        Nenhuma solicitação SEFA foi concluída no período selecionado, caso você tenha importado manualmente ou pelo manifestador ignore esse alerta
      </div>)

    }

  }

  render() {

    return (<>

      {this.alertaSefa()}

      <Tabs
        id="tabs"
        className={"tabsCalculos"}
        selectedTabId={ResultadoStore.obs.selectedResultadosTab}
        onChange={(tabId) => this.handldeChargeTab(tabId)}
        data-tut="resumo"
      >
        <Tab
          id="result_calc"
          title="Resultados de Cálculos"
          panel={<ResultadosCalculos changeTab={(tabId: string) => this.handldeChargeTab(tabId)} />}
        />

        {ResultadoStore.obs.nao_calculados && (
          <Tab
            id="memoria"
            title={
              <>
                <a
                  className="nz-nav-menu-item-calculo disabled"
                  data-tut="nao__calculados"
                >
                  <div>Não contestados - PA</div>
                  <span className="badge-emp pulse-calculo hidden-span visible-span-calculo"></span>
                </a>
              </>
            }
            panel={<NaoContestados handleContestarLote={this.handleContestarLoteCalculados.bind(this)} />}
          />
        )}

        {ResultadoStore.obs.nao_calculados_rs && (
          <Tab
            id="memoria-rs"
            title={
              <>
                <a
                  className="nz-nav-menu-item-calculo disabled"
                  data-tut="nao__calculados_rs"
                >
                  <div>Não contestados - RS</div>
                  <span className="badge-emp pulse-calculo hidden-span visible-span-calculo"></span>
                </a>
              </>
            }
            panel={<NaoContestadosRs handleContestarLote={this.handleContestarLoteCalculados.bind(this)} />}
          />
        )}

        <Tab
          id="contestacoes"
          title="Agenda de Contestações"
          panel={<Contestacoes />}
        />

        <Tab
          id="relatorios"
          title="Resultados Excel"
          panel={<Relatorios />}
        />

      </Tabs>
    </>);
  }
}
